<template>

</template>

<script>
    import PreviewElement from "./PreviewElement";
    import ButtonElement from "../../components/pagesbuilder/elements/ButtonElement";
    

    export default {
        name: "PreviewButtonElement",
        mixins: [    
            PreviewElement,
            ButtonElement
        ],
        methods: {
            elementCreationCallback () {
                if (this.isPageContext("thankyou") && this.hasContext("thank-you-section") && !this.nodeIsLinked) {
                    let productType = this.pageContext.params && this.pageContext.params.product_type ? this.pageContext.params.product_type : '';
                    let productId = this.pageContext.params && this.pageContext.params.product_id ? this.pageContext.params.product_id : '';

                    if (productId && productType) {
                        let linkTypeValue = '';
                        let linkToValue = productId;
                        let linksConfigData = this.linksManagerConfig.find(option => option.productType && option.productType === productType)
                        linkTypeValue = linksConfigData ? linksConfigData.value : '';

                        this.setLinkAttribute({attribute: 'linkType', value: linkTypeValue})
                        this.setLinkAttribute({attribute: 'linkTo', value: linkToValue})
                    }
                }
            }
        }
    }
</script>
